import React, { useCallback, useEffect, useState } from "react";
import EnterCode from "../components/OTP/EnterCode";
import { Box, Typography, useTheme } from "@mui/material";
import {
  ButtonType,
  CustomButton,
  CustomLink,
} from "@BehpardazBarin/frontend_components";
import { BackButton } from "../components/Common/BackButton";
import { useLocation, useNavigate } from "react-router-dom";
import useTimer from "../hooks/use-timer";
import { customLinkProps } from "../constants/Style";
import { useMutation } from "@tanstack/react-query";
import { checkVerificationCode, sendSms } from "../services/Login";
import { hasRedirectInfo, redirectToExternal } from "../utils/LoginUtils";
import { snackActions } from "../utils/SnackbarUtils";
import { useLoginId } from "../hooks/use-loginId";

export default function OTP() {
  const theme = useTheme();
  const COUNTDOWN_TIME = 120;
  const { timer, resetTimer, formatSeconds } = useTimer(COUNTDOWN_TIME);
  const location = useLocation();
  const navigate = useNavigate();
  const mobile = location.state?.mobile;
  const [code, setCode] = useState<string>("");
  const { loginId } = useLoginId();
  const [failedAttempts, setFailedAttempts] = useState(0);

  const checkVerificationMutation = useMutation({
    mutationFn: checkVerificationCode,
  });

  const handleCodeSubmit = useCallback((code: string) => {
    setCode(code);
  }, []);
  const handleSubmit = () => {
    console.log("code", code);
    if (!loginId || !code) {
      snackActions.error("امکان لاگین وجود ندارد");
      return;
    }
    const params = {
      loginId: loginId,
      code: code,
    };
    checkVerificationMutation.mutate(params, {
      onSuccess: (response) => {
        if (response && response.data) {
          if (hasRedirectInfo(response.data)) {
            redirectToExternal(response.data.url);
          }
        }
      },
      onError: () => {
        setFailedAttempts((prev) => prev + 1);
      },
    });
  };

  useEffect(() => {
    if (failedAttempts >= 3) {
      snackActions.error(
        "کد را ۳ بار اشتباه وارد کردید. لطفا دوباره وارد شوید."
      );
      navigate("/login");
    }
  }, [failedAttempts, navigate]);

  const sendSmsMutation = useMutation({
    mutationFn: sendSms,
  });
  const handleSendAgain = () => {
    //اگر در آدرس بار، پارامتر لاگین ایدی وجود نداشت
    if (!loginId) {
      snackActions.error("امکان لاگین وجود ندارد");
      return;
    }
    const params = {
      loginId: loginId,
    };
    sendSmsMutation.mutate(params, {
      onSuccess: (response) => {
        resetTimer();
      },
    });
  };

  const OtpText =
    timer > 0 ? (
      <Typography sx={{ color: "#828282" }}>
        {`ارسال مجدد کد تا ${formatSeconds(timer)} دیگر`}
      </Typography>
    ) : (
      <Box display="flex" justifyContent="center" gap={1}>
        <Typography sx={{ color: "#828282" }}>
          کد تایید را دریافت نکرده‌اید؟
        </Typography>
        <CustomLink
          title={"ارسال مجدد"}
          {...customLinkProps(theme)}
          handleClick={() => {
            handleSendAgain();
          }}
        />
      </Box>
    );

  return (
    <>
      {/* Back */}
      <BackButton />

      {/* Title & Info */}
      <Box mb={4} textAlign="center" sx={{ direction: "rtl" }}>
        <Typography variant="h6" sx={{ fontFamily: "IRANSansXBold", mb: 1 }}>
          کد تایید
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#1212128F",
            fontFamily: "IRANSansX",
            direction: "rtl",
          }}
        >
          {mobile ? (
            <>
              {`لطفا کد تایید ۶ رقمی ارسال شده به شماره `}
              <span style={{ display: "inline-flex" }} dir="ltr">
                {mobile}
              </span>{" "}
              {`را وارد کنید`}
            </>
          ) : (
            "لطفا کد تولید شده توسط نرم افزار را وارد کنید"
          )}
        </Typography>
      </Box>
      {/* Code Input */}
      <Box mb={3}>
        <EnterCode reset={false} callback={handleCodeSubmit} />
      </Box>
      {/* Resend Code */}
      <Box mb={4} textAlign="center">
        {mobile && OtpText}
      </Box>
      {/* Submit Button */}
      <CustomButton
        value="ثبت"
        onClickHandler={handleSubmit}
        buttonType={ButtonType.actionButton}
        customButtonStyle={{
          backgroundColor: "#00695f",
          borderRadius: "12px",
          width: "100%",
          padding: "12px 0",
        }}
        textStyle={{
          fontFamily: "IRANSansX",
        }}
      />
    </>
  );
}
